import "./navigation.scss";
import { type FC } from "react";
import { useMediaQuery } from "@onshopfront/components";
import FontAwesomeLight from "../../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";
import { NavigationMenu } from "./NavigationMenu";
import { NavigationMobile } from "./NavigationMobile";

export type NavigationType = {
    [group: string]: number | NavigationType;
};

interface Props {
    path: Array<string>;
    navigation: NavigationType;
    onShowSearch: () => void;
}

export const Navigation: FC<Props> = ({ path, navigation, onShowSearch }) => {
    const match = useMediaQuery("(max-width: 768px)");

    if(match) {
        return (
            <NavigationMobile
                path={path}
                navigation={navigation}
            />
        );
    }

    return (
        <div className="navigation w-1/3 max-w-xs text-base">
            <div className="sticky top-0 my-4 py-4 px-2 navigation-background">
                <div className="form-input mb-0!">
                    <div className="input-icon left">
                        <FontAwesomeLight icon="search" />
                    </div>
                    <input
                        placeholder="Search..."
                        onClick={(e) => {
                            e.stopPropagation();
                            onShowSearch();
                        }}
                        onFocus={(e) => {
                            e.stopPropagation();
                            onShowSearch();
                        }}
                        value=""
                        onChange={e => {
                            e.preventDefault();
                        }}
                    />
                    <div className="input-icon right">
                        /
                    </div>
                </div>
            </div>
            <NavigationMenu
                navigation={navigation}
                path={path}
            />
        </div>
    );
};
